import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import useAllowedReports from '../../hooks/useAllowedReports';
import { REPORT_TILES } from './reportTilesConfig';
import './ReportsHome.css';

const ReportsHome = () => {
  const { loading, error, isPathAllowed } = useAllowedReports();

  const visibleTiles = REPORT_TILES.filter((tile) => isPathAllowed(tile.path));

  return (
    <div className="reports-home">
      <div className="mb-5 flex flex-wrap items-center gap-3">
        <Button asChild variant="outline" className="back-button" size="md">
          <Link to="/dashboard">← Back to Home</Link>
        </Button>
      </div>

      {loading && <p className="reports-status">Loading reports…</p>}
      {!loading && error && <p className="reports-status reports-status-error">{error}</p>}
      {!loading && !error && visibleTiles.length === 0 && (
        <p className="reports-status">No reports are assigned to your profile.</p>
      )}

      {!loading && visibleTiles.length > 0 && (
        <div className="reports-grid">
          {visibleTiles.map((tile) => (
            <Link key={tile.path} to={tile.path} className="report-card">
              <h3>{tile.title}</h3>
              <p>{tile.description}</p>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default ReportsHome;
